export const addScriptTag = (id, src, options = {}) => {
  const { async = false, defer = false, onload } = options;
  const script = document.createElement('script');
  script.id = id;
  script.src = src;
  script.async = async;
  script.defer = defer;
  if (onload) {
    script.onload = onload;
  }
  document.body.appendChild(script);
};
